import Swal from "sweetalert2";
import useClipboard from "vue-clipboard3";

export default {
  install(app) {
    // Cookie
    app.config.globalProperties.$cookie = {
      get(name) {
        const cookies = document.cookie
          .split(';')
          .map(c => c.trim())
          .filter(Boolean)

        const cookie = cookies.find(c => c.startsWith(`${name}=`))
        return cookie ? decodeURIComponent(cookie.split('=')[1]) : ''
      },
      set (name, value = true, days = 180) {
        const date = new Date()
        const msPerDay = 24 * 60 * 60 * 1000

        // اگر value برابر false بود، فقط یک ثانیه اعتبار داشته باشه
        const expireTime = value ? days * msPerDay : 1000
        date.setTime(Date.now() + expireTime)

        const expires = `expires=${date.toUTCString()}`
        const safeValue = encodeURIComponent(value)

        document.cookie = `${name}=${safeValue}; ${expires}; path=/`
      },
      delete(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
      }
    }

    // Sum
    app.config.globalProperties.$sum = (key, items = []) => {
      if (!Array.isArray(items)) return 0

      const total = items.reduce((acc, row) => {
        const value= parseFloat(row?.[key]) || 0
        return acc + value
      }, 0)

      return Number.isFinite(total) ? total : 0
    }

    app.config.globalProperties.$my_alert = (msg, type = 'success', title = null, confirm_text = 'متوجه شدم') => {
      let icon_html = '<span class="icon-check-circle-bold tw-text-[34px] tw-text-green-500"></span>'

      var title_text = 'موفق'
      if (type === 'error') {
        title_text = 'خطا'
        icon_html = '<span class="icon-info-bold tw-text-[34px] tw-text-red-500"></span>'
      } else if (type === 'info') {
        title_text = 'توجه'
        icon_html = '<span class="icon-info-bold tw-text-[34px] tw-text-primary-500"></span>'
      } else if (type === 'warning') {
        title_text = 'هشدار'
        icon_html = '<span class="icon-warning tw-text-[34px] tw-text-secondry-600"></span>'
      }

      if (title) {
        title_text = title
      }

      Swal.fire({
        customClass: {
          popup: 'tw-w-[360px] tw-p-4',
          icon: 'tw-border-0 tw-w-[40px] tw-h-[40px] !tw-mt-0 tw-mb-2]',
          title: 'tw-text-small tw-pt-1 tw-pb-3 tw-text-blue-dark-500 tw-font-bold',
          htmlContainer: '!tw-pt-3 !tw-m-0 tw-border-t tw-border-blue-dark-50 tw-text-blue-dark-300 !tw-text-tiny tw-text-right',
          cancelButton: 'tw-flex-1 tw-w-full !tw-text-primary-500 !tw-border-[1.6px] !tw-border-primary-500 !tw-bg-white tw-rounded-xl',
        },
        iconHtml: icon_html,
        title: title_text,
        showConfirmButton: false,
        html: `
    <p class="tw-text-blue-dark-300">${ msg }</p>
    <div class="tw-w-full ltr tw-flex tw-gap-5 tw-justify-center tw-mt-4">
      <button id="my-confirm" class="tw-outline-none focus:tw-outline-none tw-flex-1 tw-w-full !tw-text-primary-500 !tw-border-[1.6px] !tw-border-primary-500 !tw-bg-white tw-rounded-[8px] tw-min-h-[40px] tw-px-4 tw-y-2 tw-font-bold tw-text-sm rtl">
        ${ confirm_text }
      </button>
    </div>
  `,
        didOpen: () => {
          const swal = Swal.getPopup();

          swal.querySelector('#my-confirm').addEventListener('click', () => {
            Swal.close();
          });
        },
      })

    }


    app.config.globalProperties.$toast = (msg, type = 'success', time = 5000) => {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: time,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        },
      })
      Toast.fire({
        icon: type,
        html: msg,
      })
    }

    app.config.globalProperties.$copyToClipboard = (text, message = '') => {

      const { toClipboard } = useClipboard()
      toClipboard(text)

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        },
      })

      Toast.fire({
        icon: 'success',
        html: message + " کپی شد.",
      })
    }



    app.config.globalProperties.$getNumberBar = (load, html = false) => {
      if(html) {
        let number_bar = '<div class="tw-whitespace-nowrap ltr">'
        number_bar += load.serial_number_bar ? '<span class="tw-inline-block">' +load.serial_number_bar+ '</span>|' : ''
        number_bar = number_bar + (load.number_bar ? '<span>'+load.number_bar+'</span>' : '')
        return number_bar + '</div>'

      } else {
        let number_bar = load.serial_number_bar ? load.serial_number_bar + '|' : ''
        number_bar = number_bar + (load.number_bar ? load.number_bar : '')
        return number_bar.length ? number_bar : 'ندارد'
      }
    }


    //  برای گرفتن z-index مودال‌ها از استور استفاده کن
    app.config.globalProperties.$getModalZIndex = () => {
      const store = app.config.globalProperties.$store

      // مقدار فعلی z-index از استور
      let currentZIndex = store.state.modal_z_index || 1050

      // دو واحد افزایش
      const newZIndex = currentZIndex + 10

      // ذخیره مقدار جدید در استور
      store.commit('setModalZIndex', newZIndex)

      // مقدار جدید را برگردان
      return newZIndex
    }


    app.config.globalProperties.$filterObject = (obj) =>
      Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value != null
        )
      )


    app.config.globalProperties.$detectBank = (cardNumber) => {
      const banks = {
        "603799": { name: "بانک ملی ایران", logo: "/melli/melli - www-tejiran-ir.png" },
        "589210": { name: "بانک سپه", logo: "/sepah/sepah - www-tejiran-ir.png" },
        "600130": { name: "بانک سپه (قدیم نیروهای مسلح)", logo: "/sepah/sepah - www-tejiran-ir.png" },
        "627648": { name: "بانک توسعه صادرات", logo: "/tosee saderat/tosee-taderat-www-tejiran-ir.png" },
        "603769": { name: "بانک صادرات", logo: "/saderat/saderat - www-tejiran-ir.png" },
        "627961": { name: "بانک صنعت و معدن", logo: "/sanat o madan/sanat o madan-www-tejiran-ir.png" },
        "603770": { name: "بانک کشاورزی", logo: "/keshavarzi/keshavarzi-www-tejiran-ir.png" },
        "628023": { name: "بانک مسکن", logo: "/maskan/maskan - www-tejiran-ir.png" },
        "502908": { name: "بانک توسعه تعاون", logo: "/tosee taavon/tosee-taavon-www-tejiran-ir.png" },
        "627412": { name: "بانک اقتصاد نوین", logo: "/eghtesad/eghtesad - www-tejiran-ir.png" },
        "622106": { name: "بانک پارسیان", logo: "/parsian/parsian - www-tejiran-ir.png" },
        "627884": { name: "بانک پارسیان", logo: "/parsian/parsian - www-tejiran-ir.png" },
        "604708": { name: "بانک پارسیان", logo: "/parsian/parsian - www-tejiran-ir.png" },
        "502229": { name: "بانک پاسارگاد", logo: "/pasargad/pasargad-www-tejiran-ir.png" },
        "639347": { name: "بانک پاسارگاد", logo: "/pasargad/pasargad-www-tejiran-ir.png" },
        "636214": { name: "بانک آینده", logo: "/ayande/ayande - www-tejiran-ir.png" },
        "502806": { name: "بانک شهر", logo: "/shahr/shahr - www-tejiran-ir.png" },
        "502938": { name: "بانک دی", logo: "/dey/dey - www-tejiran-ir.png" },
        "627353": { name: "بانک تجارت", logo: "/tejarat/tejarat - www-tejiran-ir.png" },
        "585983": { name: "بانک تجارت", logo: "/tejarat/tejarat - www-tejiran-ir.png" },
        "639607": { name: "بانک سرمایه", logo: "/sarmaye/sarmaye - www-tejiran-ir.png" },
        "502987": { name: "بانک مهر اقتصاد", logo: "/mehre eghtesad/mehr eghtesad - www-tejiran-ir.png" },
        "627488": { name: "بانک کارآفرین", logo: "/karafarin/karafarin - www-tejiran-ir.png" },
        "505785": { name: "بانک ایران‌زمین", logo: "/iranzamin/iranzamin-www-tejiran-ir.png" },
        "606373": { name: "بانک قرض‌الحسنه مهر ایران", logo: "/mehr/mehr.png" },
        "505416": { name: "بانک گردشگری", logo: "/gardeshgari/gardeshgari-www-tejiran-ir.png" },
        "606256": { name: "مؤسسه اعتباری ملل", logo: "/mellal/mellal - www-tejiran-ir (1).png" },
        "639346": { name: "بانک سینا", logo: "/sina/sina - www-tejiran-ir.png" },
        "504172": { name: "بانک قرض‌الحسنه رسالت", logo: "/resalat/resalat - www-tejiran-ir.png" },
        "589463": { name: "بانک رفاه کارگران", logo: "/refah/refah - www-tejiran-ir.png" },
        "610433": { name: "بانک ملت", logo: "/mellat/mellat - www-tejiran-ir.png" },
        "991975": { name: "بانک ملت", logo: "/mellat/mellat - www-tejiran-ir.png" },
        "627381": { name: "بانک انصار", logo: "/ansar/ansar - www-tejiran-ir.png" },
        "505801": { name: "مؤسسه اعتباری کوثر", logo: "/kosar/kosar - www-tejiran-ir.png" },
        "636949": { name: "بانک حکمت ایرانیان", logo: "/hekmat/hekmat - www-tejiran-ir.png" },
        "507677": { name: "مؤسسه اعتباری نور", logo: "/noor/noor - www-tejiran-ir.png" },
        "627760": { name: "پست بانک ایران", logo: '/postbank/postbank6.png' },
        "628157": { name: "موسسه اعتباری توسعه", logo: null },
        "639599": { name: "بانک قوامین", logo: null },
      };


      if (!cardNumber || cardNumber.length < 6) return null;
      const bin = cardNumber.slice(0, 6);
      const bank = banks[bin];

      if (bank) {
        return {
          name: bank.name || 'نامشخص',
          logo: `/img/banks-logo/${bank.logo}`,
        };
      } else {
        return {
          name: 'نامشخص',
          logo: `/img/banks-logo/markazi/markazi.jpg`,
        };
      }
    }

      app.config.globalProperties.$showConfirm = (data, afterConfirm, afterDeny = () => {}) => {

        let icon_html= '<span class="icon-info-bold tw-text-[34px] tw-text-primary-500"></span>'

        const icon = data.icon || 'warning'
        if(icon === 'warning') icon_html = '<span class="icon-warning tw-text-[34px] tw-text-secondry-600"></span>'
        if(icon === 'info') icon_html = '<span class="icon-info-bold tw-text-[34px] tw-text-primary-500"></span>'
        if(icon === 'question') icon_html = '<span class="icon-question-mark tw-text-[34px] tw-text-primary-500"></span>'

        Swal.fire({
          customClass: {
            popup: 'tw-w-[360px] tw-p-4',
            icon: 'tw-border-0 tw-w-[40px] tw-h-[40px] !tw-mt-0 tw-mb-2]',
            title: 'tw-text-small tw-pt-1 tw-pb-3 tw-text-blue-dark-500 tw-font-bold',
            htmlContainer: '!tw-pt-3 !tw-m-0 tw-border-t tw-border-blue-dark-50 tw-text-blue-dark-300 !tw-text-tiny tw-text-right',
            cancelButton: 'tw-flex-1 tw-w-full !tw-text-primary-500 !tw-border-[1.6px] !tw-border-primary-500 !tw-bg-white tw-rounded-xl',
          },
          iconHtml: icon_html,
          title: data.title,
          showConfirmButton: false,
          html: `
    <p class="tw-text-blue-dark-300">${ data.text || '' }</p>
    <div class="tw-w-full ltr tw-flex tw-gap-5 tw-justify-center tw-mt-4">
      <button id="my-confirm" class="tw-outline-none focus:tw-outline-none tw-flex-1 tw-w-full !tw-text-primary-500 !tw-border-[1.6px] !tw-border-primary-500 !tw-bg-white tw-rounded-[8px] tw-min-h-[40px] tw-px-4 tw-y-2 tw-font-bold tw-text-sm rtl">
        ${
          data?.confirm_icon ? `<span class="icon-${data.confirm_icon} tw-text-[24px] tw-ml-2 tw-align-middle"></span>` : ''
          }
        ${ data.confirm_text || 'بله' }
      </button>
      <button id="my-deny" class="tw-outline-none focus:tw-outline-none tw-flex-1 tw-w-full !tw-text-primary-500 !tw-border-[1.6px] !tw-border-primary-500 !tw-bg-white tw-rounded-[8px] tw-min-h-[40px] tw-px-4 tw-y-2  tw-font-bold tw-text-sm">انصراف</button>
    </div>
  `,
          didOpen: () => {
            const swal = Swal.getPopup();

            swal.querySelector('#my-confirm').addEventListener('click', () => {
              Swal.close();
              // Confirmed

              afterConfirm()
            });

            swal.querySelector('#my-deny').addEventListener('click', () => {
              Swal.close();
              afterDeny()
            });
          }
        })
      }
  },
}
